module.exports = __webpack_public_path__ + "img/LocalBee white.dbbfb359.svg";